import { render, staticRenderFns } from "./bawangcan.vue?vue&type=template&id=b41935cc&scoped=true"
import script from "./bawangcan.vue?vue&type=script&lang=js"
export * from "./bawangcan.vue?vue&type=script&lang=js"
import style0 from "./bawangcan.vue?vue&type=style&index=0&id=b41935cc&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b41935cc",
  null
  
)

export default component.exports